import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/FilterCondition/FilterCondition.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as smApi from '@gmini/sm-api-sdk';
import { Controller, useWatch } from 'react-hook-form';
import { useCallback, useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { useSnackbar } from 'notistack';
import { prepareSourceListForApi } from "../../utils/prepareSourceListForApi";
import { getFilterOperatorIcon, filterOperatorList } from "../../constants";
import { FilterConditionItem } from "../FilterConditionItem";
import { ConditionsWrapper, Root, RemoveButton } from "./FilterCondition.styled";
import { validateValueField } from "./validateValueField";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var errorDuration = 3000;
var minLengthMessage = 'Значение должно быть не менее 3 символов';
export var FilterCondition = function FilterCondition(_ref) {
  var _condition$property, _condition$property2, _condition$operator;

  var onRemove = _ref.onRemove,
      control = _ref.control,
      idx = _ref.idx,
      sourceList = _ref.sourceList,
      useFilterPropertyValues = _ref.useFilterPropertyValues,
      propertyList = _ref.propertyList,
      classifierId = _ref.classifierId,
      classifierVersion = _ref.classifierVersion,
      _onChange = _ref.onChange,
      dependencies = _ref.dependencies;
  var valuePending = useStore(smApi.UserClassifier.Property.List.fetchElementPropertyValues.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 38,
      column: 23
    },
    name: "FilterCondition",
    sid: "FilterCondition /src/components/FilterPanel/components/FilterCondition/FilterCondition.tsx [38, 23]"
  });
  var fetchPropertiesPending = useStore(smApi.UserClassifier.Property.List.fetchElementProperties.defaultContext.pending$, {
    loc: {
      file: _effectorFileName,
      line: 42,
      column: 33
    },
    name: "FilterCondition",
    sid: "FilterCondition /src/components/FilterPanel/components/FilterCondition/FilterCondition.tsx [42, 33]"
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      valueError = _useState2[0],
      setValueError = _useState2[1];

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var condition = useWatch({
    name: "conditions.".concat(idx),
    control: control
  });
  var propertyValueList = useFilterPropertyValues({
    propertyId: (_condition$property = condition.property) === null || _condition$property === void 0 ? void 0 : _condition$property.id
  });
  useEffect(function () {
    if (valueError) {
      enqueueSnackbar(minLengthMessage, {
        variant: 'error',
        autoHideDuration: errorDuration
      });
      setTimeout(function () {
        return setValueError(false);
      }, errorDuration);
    }
  }, [enqueueSnackbar, valueError]);
  var fetchPropertyValues = useCallback(function (conditionProperty) {
    smApi.UserClassifier.Property.List.fetchElementPropertyValues.defaultContext({
      classifierId: classifierId,
      classifierVersion: classifierVersion,
      propertyId: conditionProperty.id,
      sources: prepareSourceListForApi(sourceList, dependencies)
    });
  }, [classifierId, classifierVersion, dependencies, sourceList]);
  var filled = Boolean(((_condition$property2 = condition.property) === null || _condition$property2 === void 0 ? void 0 : _condition$property2.id) && ((_condition$operator = condition.operator) === null || _condition$operator === void 0 ? void 0 : _condition$operator.value) && condition.value);
  var renderOptionIconOperator = useCallback(function (option, hover) {
    return option ? getFilterOperatorIcon(option.value, hover) : null;
  }, []);
  var onChangeProperty = useCallback(function (_ref2) {
    var _condition$property3;

    var value = _ref2.value;

    if (value && (value === null || value === void 0 ? void 0 : value.id) !== ((_condition$property3 = condition.property) === null || _condition$property3 === void 0 ? void 0 : _condition$property3.id)) {
      fetchPropertyValues(value);
    }

    var nextConditionItem = _objectSpread(_objectSpread({}, condition), {}, {
      property: value,
      value: ''
    });

    _onChange === null || _onChange === void 0 ? void 0 : _onChange(idx, nextConditionItem);
  }, [condition, fetchPropertyValues, idx, _onChange]);
  var onChangeValue = useCallback(function (value) {
    var isValidField = validateValueField(condition, value, propertyValueList);

    if (!isValidField) {
      setValueError(true);
    } else {
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(idx, _objectSpread(_objectSpread({}, condition), {}, {
        value: value
      }));
    }
  }, [condition, idx, _onChange, propertyValueList]);
  return /*#__PURE__*/_jsxs(Root, {
    filled: filled,
    children: [/*#__PURE__*/_jsxs(ConditionsWrapper, {
      children: [/*#__PURE__*/_jsx(Controller, {
        render: function render(_ref3) {
          var field = _ref3.field;
          return /*#__PURE__*/_jsx(FilterConditionItem, {
            value: field.value,
            label: "\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u043E",
            searchable: true,
            filled: filled,
            freeSolo: false,
            options: propertyList,
            getOptionLabel: function getOptionLabel(option) {
              return option ? "".concat(option.groupName, ".").concat(option.name) : '';
            },
            onChange: onChangeProperty,
            isOptionEqualToValue: function isOptionEqualToValue(option, value) {
              return (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id);
            },
            disabled: fetchPropertiesPending
          });
        },
        defaultValue: null,
        name: "conditions.".concat(idx, ".property"),
        control: control
      }), /*#__PURE__*/_jsx(Controller, {
        render: function render(_ref4) {
          var field = _ref4.field;
          return /*#__PURE__*/_jsx(FilterConditionItem, {
            value: field.value,
            label: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F",
            options: filterOperatorList,
            getOptionLabel: function getOptionLabel(option) {
              return (option === null || option === void 0 ? void 0 : option.label) || '';
            },
            filled: filled,
            onChange: function onChange(_ref5) {
              var value = _ref5.value;
              _onChange === null || _onChange === void 0 ? void 0 : _onChange(idx, _objectSpread(_objectSpread({}, condition), {}, {
                operator: value
              }));
            },
            isOptionEqualToValue: function isOptionEqualToValue(option, value) {
              return (option === null || option === void 0 ? void 0 : option.value) === (value === null || value === void 0 ? void 0 : value.value);
            },
            renderOptionIcon: renderOptionIconOperator
          });
        },
        defaultValue: null,
        name: "conditions.".concat(idx, ".operator"),
        control: control
      }), /*#__PURE__*/_jsx(Controller, {
        render: function render(_ref6) {
          var _condition$property4;

          var field = _ref6.field;
          return /*#__PURE__*/_jsx(FilterConditionItem, {
            value: field.value,
            label: "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435",
            searchable: true,
            filled: filled,
            options: propertyValueList,
            disabled: !((_condition$property4 = condition.property) !== null && _condition$property4 !== void 0 && _condition$property4.id) || valuePending || fetchPropertiesPending,
            getOptionLabel: function getOptionLabel(option) {
              return option || '';
            },
            onClickAway: function onClickAway(_ref7) {
              var inputValue = _ref7.inputValue;
              onChangeValue(inputValue);
            },
            onChange: function onChange(_ref8) {
              var value = _ref8.value;
              return onChangeValue(value);
            },
            error: valueError,
            isOptionEqualToValue: function isOptionEqualToValue() {
              return false;
            }
          });
        },
        defaultValue: '',
        name: "conditions.".concat(idx, ".value"),
        control: control
      })]
    }), /*#__PURE__*/_jsx(RemoveButton, {
      filled: filled,
      onClick: onRemove
    })]
  });
};